import { proxy } from 'valtio';

export type TemplatePickerState = {
  openedFrom: 'board-creation' | 'toolbar';
};

export const defaultTemplatePickerState: TemplatePickerState = {
  openedFrom: 'toolbar',
};

export const currentTemplatePickerState: TemplatePickerState = proxy(
  defaultTemplatePickerState
);
